import { render, staticRenderFns } from "./ifisea.vue?vue&type=template&id=10210842&scoped=true&"
import script from "./ifisea.vue?vue&type=script&lang=js&"
export * from "./ifisea.vue?vue&type=script&lang=js&"
import style0 from "./ifisea.vue?vue&type=style&index=0&id=10210842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10210842",
  null
  
)

export default component.exports